import { render } from "./create-area-container.vue?vue&type=template&id=c21cfcea&scoped=true&ts=true"
import script from "./create-area-container.vue?vue&type=script&lang=ts"
export * from "./create-area-container.vue?vue&type=script&lang=ts"

import "./create-area-container.vue?vue&type=style&index=0&id=c21cfcea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21cfcea"]])

export default __exports__